import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=c0e1f660&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&lang=js&"
export * from "./UserAgreement.vue?vue&type=script&lang=js&"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=c0e1f660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e1f660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0e1f660')) {
      api.createRecord('c0e1f660', component.options)
    } else {
      api.reload('c0e1f660', component.options)
    }
    module.hot.accept("./UserAgreement.vue?vue&type=template&id=c0e1f660&scoped=true&", function () {
      api.rerender('c0e1f660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agreement/UserAgreement.vue"
export default component.exports